import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subject} from 'rxjs';
import {debounceTime, map, startWith, takeUntil} from 'rxjs/operators';
import {MatSelectChange} from "@angular/material";
import * as Fuse from "fuse.js";

@Component({
    selector: 'select-search',
    templateUrl: 'select-search.component.html',
    styleUrls: ['select-search.component.less', '../forms/forms.less'],
    encapsulation: ViewEncapsulation.ShadowDom
})
export class SelectSearchComponent implements OnInit, OnDestroy {
    filteredOptions: any[] = [];

    @ViewChild('search', {static: false}) searchTextBox: ElementRef;
    selectFormControl = new FormControl();
    searchTextboxControl = new FormControl();

    placeholder: string = 'Search';
    _data: any[];

    emitSelect(newSelection: MatSelectChange) {
        this.valueChange.emit(newSelection.value);
        this.selectChange.emit(newSelection);
    }

    /**
     * For running a function when the selection was changed.
     */
    @Output()
    selectChange: EventEmitter<MatSelectChange> = new EventEmitter<MatSelectChange>();

    /**
     * For binding to the input value;
     */
    @Output()
    valueChange: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    set value(value: any) {
        if (value !== null) {
            this.selectFormControl.setValue(value);
        }
    }

    get disabled(): boolean {
        return this.selectFormControl.disabled;
    }

    @Input()
    set disabled(state: boolean) {
        if (state) {
            this.selectFormControl.disable();
        } else {
            this.selectFormControl.enable();
        }
    }

    @Input()
    fill_stubs = false;

    @Input()
    data: any[] = [];

    /*
    Please ensure that fuse works when using the string function.
     */

    @Input()
    stringFunction: (obj: any) => string = (obj) => obj.attributes.description ?
        obj.attributes.name + ' - ' + obj.attributes.description :
        obj.attributes.name;

    @Input()
    label: string = '';

    @Input() classes: string;
    description_map: { [key: string]: string } = {};

    search_options: any = {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: [
            "attributes.name",
            "attributes.description",
        ]
    };
    private onDestroy: Subject<void> = new Subject();

    fuse: any;

    constructor() {
    }

    ngOnInit() {
        const ctrl = this;

        setTimeout(() => {
            this.data.map(item => {
                this.description_map[item.id] = this.stringFunction(item);
            });

            this.fuse = new Fuse(this.data, this.search_options);

            /**
             * Set filter event based on value changes
             */
            this.searchTextboxControl.valueChanges
                .pipe(takeUntil(this.onDestroy),
                    debounceTime(300),
                    startWith<string>(''),
                    map(name => this._filter(name))
                ).subscribe(values => {
                this.filteredOptions = values;
            });

            if (this.fill_stubs && ctrl.selectFormControl.value && ctrl.selectFormControl.value.id) {
                ctrl.data.forEach((item) => {
                    if (item.id === ctrl.selectFormControl.value.id || item.attributes.name === ctrl.selectFormControl.value) {
                        ctrl.selectFormControl.setValue(item);
                    }
                });
            }
        });
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.unsubscribe();
    }

    /**
     * Used to filter data based on search input
     */
    private _filter(name: string = ''): String[] {
        const filterValue = name.toLowerCase();

        if (name === '') {
            return this.data
        }

        // Set selected values to retain the selected checkbox state
        let filteredList = this.data.filter(option => this.description_map[option.id].toLowerCase().indexOf(filterValue) >= 0);
        return this.fuse.search(name);
    }

    openedChange(e: boolean) {
        // Set search textbox value as empty while opening selectbox
        this.searchTextboxControl.patchValue('');
        // Focus to search textbox while clicking on selectbox
        if (e == true) {
            this.searchTextBox.nativeElement.focus();
        }
    }

    /**
     * Clearing search textbox value
     */
    clearSearch(event) {
        event.stopPropagation();
        this.placeholder = 'Search';
        this.searchTextboxControl.patchValue('');
    }

    /**
     * Set selected values to retain the state
     */

}

/**  Copyright 2018 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that
 can be found in the LICENSE file at http://angular.io/license */
